import { AnyAction, Reducer } from 'redux';
import {
  GlobalAction,
  GlobalActions,
  isAzam,
  ReplaceState,
  WrappedSavedStates,
  WrappedSavedStatesLoaded
} from '@ps20-frontend/shop-integration-redux';
import {
  App,
  getInactiveProductApps,
  isBeibehalten,
} from '@ps20-frontend/frontend-models';
import dayjs from 'dayjs';
import { DATEFORMAT_SHORT_ISO } from '@ps20-frontend/utils';
import { Feature } from '@ps20/bff-models';
import { loadAndMigrateDashboardState } from '../migrations';
import { IAppState } from '../appState';


export const rootReducer =
  (reducer: Reducer) =>
    (state: IAppState, action: AnyAction): IAppState => {
      switch (action.type) {
        case GlobalActions.REPLACE_STATE: {
          const actionPayload: ReplaceState<IAppState> = action.payload;
          if (actionPayload.appId === App.SHOP_DASHBOARD) {
            return actionPayload.appState;
          }
          return state;
        }
        case GlobalActions.SAVED_STATES_LOADED: {
          const payload = (action as GlobalAction<WrappedSavedStatesLoaded>).payload;
          const actionPayload: WrappedSavedStates = payload.savedStatesLoaded;
          const loadedAppState = actionPayload.find(
            loadedState => loadedState.appId === App.SHOP_DASHBOARD
          );
          if (loadedAppState) {
            if (isAzam(state.transientState.role)) {
              delete loadedAppState.state.immobilien;
            }

            const migratedState = loadAndMigrateDashboardState(state, loadedAppState.state);
            return filterOutInactiveTkvFromWarenkorb(migratedState);
          } else {
            return state;
          }
        }
        default:
          return reducer(state, action);
      }
    };

export function filterOutInactiveTkvFromWarenkorb(state: IAppState): IAppState {
  const inactiveApps = getInactiveProductApps(
    state.transientState.featureToggles as { [key: string]: boolean },
  );
  return {
    ...state,
    warenkorb:
      state.warenkorb?.filter(
        item => !inactiveApps.includes(item.appId) || isBeibehalten(item),
      ) ?? [],
  };
}

export function processActionsForVorteilsrabattState(
  loadedAndMigratedDashboardState: IAppState
): IAppState {
  const isFtVorteilsRabatt =
    loadedAndMigratedDashboardState.transientState.featureToggles[Feature.VORTEILSRABATT];
  if (isFtVorteilsRabatt) {
    const today = dayjs().format(DATEFORMAT_SHORT_ISO);
    loadedAndMigratedDashboardState.warenkorb.forEach(warenkorbProdukt => {
      warenkorbProdukt.angebotsdatum = warenkorbProdukt.angebotsdatum || today;
      if (warenkorbProdukt.rbd > 0 || warenkorbProdukt.treuebonus > 0) {
        loadedAndMigratedDashboardState.transientState.showVorteilsRabattHinweis = true;
      }
      if (!warenkorbProdukt.beibehalten) {
        delete warenkorbProdukt.rbd;
        delete warenkorbProdukt.treuebonus;
      }
    });
  }
  return loadedAndMigratedDashboardState;
}
